export const alternateIdTypes: Record<string, string> = {
  CERS: "CERS Facility",
  CERS_BUSINESS: "CERS Business",
  CLEAN_HARBORS: "Clean Harbors",
  CLEAN_EARTH: "Clean Earth",
  ELK_ENVIRONMENTAL: "Elk Environmental",
  REPUBLIC: "Republic",
  US_ECOLOGY: "US Ecology",
  OTHER_VENDOR: "Other Waste Vendor",
  EPA: "EPA ID",
  FRS: "FRS ID",
  ICIS: "ICIS ID",
  ISO_CERTIFICATION: "ISO Certification Number",
  KY_EEC: "KY EEC Number",
  NPDES: "NPDES ID",
  OCC_OPERATOR: "OCC Operator Number",
  OH_AGENCY_ID: "Ohio Agency ID",
  OH_REVENUE_ID: "Ohio Revenue ID",
  PA_RESIDUAL_WASTE: "PA Residual Waste Number",
  RCRAINFO: "RCRAInfo",
  RMP: "RMP ID",
  RRC_P5: "RRC P5 Number",
  SAFETY_KLEEN: "Safety Kleen",
  STEERS_CN: "STEERS CN",
  STEERS_RN: "STEERS RN",
  TIER2_AZ: "Tier 2 Portal ID (AZ)",
  TIER2_KS: "Tier 2 Portal ID (KS)",
  TIER2_LA: "Tier 2 Portal ID (LA)",
  TIER2_MANAGER: "Tier 2 Portal ID (T2M)",
  TIER2_MO: "Tier 2 Portal ID (MO)",
  TIER2_MO_COMPANY: "Tier 2 Portal ID (MO Company)",
  TIER2_NJ: "Tier 2 Portal ID (NJ)",
  TIER2_SD: "Tier 2 Portal ID (SD)",
  TIER2_WA: "Tier 2 Portal ID (WA)",
  TRADEBE: "Tradebe",
  TRI: "TRI ID",
  TX_SOLID_WASTE_REGISTRATION: "TX Solid Waste Registration",
};

/**
 * The key whose key or label equals the text, ignoring case and surrounding
 * whitespace; null when nothing matches. Users see and type labels, so typed
 * text has to resolve to the stored key.
 */
export function findOptionKey(text: string, options: Record<string, string>): string | null {
  const needle = text.trim().toLowerCase();
  const match = Object.entries(options).find(
    ([key, label]) => key.toLowerCase() === needle || label.toLowerCase() === needle
  );
  return match ? match[0] : null;
}

/** The alternateIdTypes key for a key or label; free text that matches nothing passes through. */
export function resolveAlternateIdType(type: string): string {
  return findOptionKey(type, alternateIdTypes) ?? type;
}
